<template>
  <div>
    <loading-gif
      :loadingModal="loadingModal"
      :topOfModal="topOfLoadingModal"
      :whichGifToPlay="whichGifToPlay"
      :bottomOfModal="bottomOfLoadingModal"
      @loadingModal="closeLoadingModal"
    ></loading-gif>
    <minting-parchment
      :minted="minted"
      :mintingPriceRepresentation="mintingPriceRepresentation"
      :mintingPaused="mintingPaused"
      @mintClicked="mintClicked"
      @mintAndStakeClicked="mintAndStakeClicked"
    ></minting-parchment>
  </div>
</template>

<script>
import { ethers, utils } from "ethers";
import {
    eggsNFTAddress,
    eggsGameAddress,
    eggsTokenAddress
} from "../conf";
import EggGame from "../contracts/EggGame.json";
import EggG from "../contracts/EggG.json";
import EggsToken from "../contracts/EGG.json";
import LoadingGif from "../components/LoadingGif.vue";
import MintingParchment from "../components/MintingParchment.vue";
export default {
  components: {
    MintingParchment,
    LoadingGif,
  },
  data() {
    return {
      provider: null,
      minted: 0,
      mintingPriceRepresentation: "0",
      mintingPrice: 0,
      loadingModal: false,
      whichGifToPlay: "images/gifs/chicken-fall-failed.gif",
      topOfLoadingModal: "Loading",
      bottomOfLoadingModal: "Loading",
      mintingPaused: false,
      isPublicSaleStarted:false
    };
  },
  computed: {
    eggsToken() {
      this.provider =
        this.provider || new ethers.providers.Web3Provider(window.ethereum);
      return new ethers.Contract(
        eggsTokenAddress,
        EggsToken.abi,
        this.provider.getSigner()
      );
    },
    eggsGameContract() {
      this.provider =
        this.provider || new ethers.providers.Web3Provider(window.ethereum);
      return new ethers.Contract(
        eggsGameAddress,
        EggGame.abi,
        this.provider.getSigner()
      );
    },
    eggsNFT() {
      this.provider =
        this.provider || new ethers.providers.Web3Provider(window.ethereum);
      return new ethers.Contract(
        eggsNFTAddress,
        EggG.abi,
        this.provider.getSigner()
      );
    },
    eggsGameContract() {
      this.provider =
        this.provider || new ethers.providers.Web3Provider(window.ethereum);
      return new ethers.Contract(
        eggsGameAddress,
        EggGame.abi,
        this.provider.getSigner()
      );
    },
  },
  mounted() {
    this.getMintingPrice();
    this.getMinted();
    this.checkMintingPaused();
    this.eggsNFT.on("ChickenMinted", (tokenID) => {
      this.anNftMinted(tokenID, "Chicken");
    });
    this.eggsNFT.on("SnakeMinted", (tokenID) => {
      this.anNftMinted(tokenID, "Snake");
    });
    this.eggsNFT.on("RoosterMinted", (tokenID) => {
      this.anNftMinted(tokenID);
    });
    this.eggsNFT.on("SnakeStolen", (tokenID) => {
        this.anNftStolen("snake")
    })
    this.eggsNFT.on("ChickenStolen", (tokenID) => {
        this.anNftStolen("chicken")
    })
    this.eggsNFT.on("RoosterStolen", (tokenID) => {
        this.anNftStolen("rooster")
    })
  },
  methods: {
    handleContractErrorMessage(response) {
      let Message = response.data.message.replace(
        "VM Exception while processing transaction: revert",
        ""
      );
      if (Message === "") {
        Message = "An error occured.";
      }
      this.$emit("openToast", {
        variant: "danger",
        message: `Error: ${Message}`,
      });
    },
    closeLoadingModal(value) {
      this.loadingModal = value;
    },
    checkPublicSaleStarted() {
      this.eggsGameContract
        .hasPublicSaleStarted()
        .then((result) => {
          this.isPublicSaleStarted = result;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    getMaxTokens(){
        this.eggsNFT.maxTokens()
        .then((result) => {this.maxTokens = result})
        .catch((error) => {
            this.handleContractErrorMessage(error)
        })
    },
    getMintingPrice() {
      this.eggsGameContract
        .currentPriceToMint()
        .then((result) => {
          this.mintingPriceRepresentation = utils.formatUnits(result);
          this.mintingPrice = result;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    getMinted() {
      this.eggsNFT
        .minted()
        .then((result) => {
          this.minted = result;
          this.mintTubeWidth = (this.minted * 100) / this.maxTokens;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    async checkMintingPaused() {
      await this.eggsGameContract
        .paused()
        .then((result) => {
          this.mintingPaused = result;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    mintClicked(value) {
      let total_price = (this.mintingPrice * value).toString();
      const options = {
        value: total_price,
        // gasLimit: utils.hexlify(2500000),
        // gasPrice: utils.parseUnits('50', "gwei")
      };
      this.eggsGameContract
        .mint(value, false, options)
        .then((result) => {
          this.topOfLoadingModal = "MINTING";
          this.whichGifToPlay = "images/gifs/minter.gif";
          this.bottomOfLoadingModal = "";
          this.loadingModal = true;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    mintAndStakeClicked(value) {
      let total_price = (this.mintingPrice * value).toString();
      const options = {
        value: total_price,
      };
      this.eggsGameContract
        .mint(value, true, options)
        .then((result) => {
          this.topOfLoadingModal = "MINTING";
          this.whichGifToPlay = "images/gifs/minter.gif";
          this.bottomOfLoadingModal = "";
          this.loadingModal = true;
        })
        .catch((error) => {
          this.handleContractErrorMessage(error);
        });
    },
    async anNftStolen(NftType){
        
        this.checkMintingPaused()
        this.getMinted()
        this.getMintingPrice()
        this.checkPublicSaleStarted()
        this.getEggsBalance()

        if (this.loadingModal){
            this.topOfLoadingModal = 'How it played out'
            this.whichGifToPlay = `images/gifs/${NftType}stolen.png`
            this.bottomOfLoadingModal = `You ${NftType} was stolen`

            let closeStolenPopup = setInterval(()=> {
                this.loadingModal = false
                clearInterval(closeStolenPopup)
            }, 5000)
        }
    },
    async anNftMinted(decTokenId, NftType) {
      // let decTokenId = ethers.BigNumber.from(tokenID._hex).toString();
      this.checkMintingPaused();
      this.getMinted();
      this.getMintingPrice();
      this.checkPublicSaleStarted();
      this.getEggsBalance();

      if (this.loadingModal) {
        this.topOfLoadingModal = "How it played out";
        this.whichGifToPlay = `images/gifs/${NftType}.png`;
        this.bottomOfLoadingModal = `You minted ${NftType} #${decTokenId}`;
        let onTheWayTimer = setInterval(() => {
          this.topOfLoadingModal = "Chill";
          this.whichGifToPlay = "images/gifs/boxgifnew.gif";
          this.bottomOfLoadingModal = `Your ${NftType} is safely on the way`;
          clearInterval(onTheWayTimer);
        }, 4000);
        let closePopupTimer = setInterval(() => {
          this.loadingModal = false;
          clearInterval(closePopupTimer);
        }, 9000);
      }
    },
    async getEggsBalance() {
      const balance = await this.eggsToken.balanceOf(ethereum.selectedAddress);
      this.eggsTokenRepresentation = utils.formatUnits(balance);
      this.$emit("eggsBalance", this.eggsTokenRepresentation);
    },
  },
};
</script>

<style>
</style>